import { Button, Form, Input, InputNumber, DatePicker, message } from "antd";
import dayjs from "dayjs";
import {
  useGetCompanyDataQuery,
  useSaveCompanyDataMutation,
} from "../../../redux/Service/companyDataApi";
import { useEffect } from "react";

function CompanyData() {
  const [form] = Form.useForm();

  const { data: companyData, isLoading } = useGetCompanyDataQuery(undefined);
  const company = companyData?.ResponseObject?.[0] ?? [];

  const [saveData, { isLoading: isAdding }] = useSaveCompanyDataMutation();

  useEffect(() => {
    if (Object.keys(company).length) {
      let data = { ...company };

      if (data.FirstDate) {
        data.FirstDate = dayjs(data.FirstDate, "YYYY-MM-DD");
      }
      if (data.LastDate) {
        data.LastDate = dayjs(data.LastDate, "YYYY-MM-DD");
      }

      form.setFieldsValue(data);
    }
  }, [company, form]);

  const handleOk = async (values: any) => {
    const body = {
      ...values,
      FirstDate: values.FirstDate
        ? dayjs(values.FirstDate).format("YYYY-MM-DD")
        : null,
      LastDate: values.LastDate
        ? dayjs(values.LastDate).format("YYYY-MM-DD")
        : null,
    };

    try {
      const response = await saveData(body).unwrap();
      if (response?.ResponseObject == true) {
        message.success("تمت إضافة عملية القبض بنجاح");
      } else {
        message.error("حدث خطأ أثناء الإضافة");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleOk}
      layout="vertical"
      className="grid grid-cols-1 md:grid-cols-2 gap-3"
    >
      <Form.Item
        name="CompName"
        label="اسم الشركة"
        rules={[{ required: true, message: "الرجاء إدخال اسم الشركة" }]}
      >
        <Input placeholder="اسم الشركة" />
      </Form.Item>

      <Form.Item
        name="Addrss"
        label="العنوان"
        rules={[{ required: true, message: "الرجاء إدخال العنوان" }]}
      >
        <Input placeholder="العنوان" />
      </Form.Item>

      <Form.Item
        name="Email"
        label="البريد الإلكتروني"
        rules={[{ type: "email", message: "صيغة غير صحيحة" }]}
      >
        <Input placeholder="example@domain.com" />
      </Form.Item>

      <Form.Item
        name="RegNumber"
        label="رقم السجل التجاري"
        rules={[{ required: true, message: "الرجاء إدخال رقم السجل" }]}
      >
        <Input placeholder="رقم السجل التجاري" />
      </Form.Item>

      <Form.Item
        name="TaxCard"
        label="بطاقة ضريبية"
        rules={[{ required: true, message: "الرجاء إدخال البطاقة الضريبية" }]}
      >
        <Input placeholder="بطاقة ضريبية" />
      </Form.Item>

      <Form.Item name="RegTax" label="الرقم الضريبي">
        <Input placeholder="الرقم الضريبي (إن وجد)" />
      </Form.Item>

      <Form.Item
        name="Fax"
        label="الفاكس"
        rules={[{ required: true, message: "الرجاء إدخال الفاكس" }]}
      >
        <InputNumber style={{ width: "100%" }} placeholder="الفاكس" />
      </Form.Item>

      <Form.Item
        name="Phone"
        label="الهاتف"
        rules={[{ required: true, message: "الرجاء إدخال الهاتف" }]}
      >
        <InputNumber style={{ width: "100%" }} placeholder="الهاتف" />
      </Form.Item>

      <Form.Item
        name="Mobile"
        label="الجوال"
        rules={[{ required: true, message: "الرجاء إدخال الجوال" }]}
      >
        <InputNumber style={{ width: "100%" }} placeholder="الجوال" />
      </Form.Item>

      <Form.Item
        name="FirstDate"
        label="تاريخ البداية"
        rules={[{ required: true, message: "الرجاء اختيار تاريخ البداية" }]}
      >
        <DatePicker className="w-full" format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item
        name="LastDate"
        label="تاريخ النهاية"
        rules={[{ required: true, message: "الرجاء اختيار تاريخ النهاية" }]}
      >
        <DatePicker className="w-full" format="YYYY-MM-DD" />
      </Form.Item>

      <div className="flex items-center gap-4">
        <Button
          type="primary"
          htmlType="submit"
          loading={isLoading || isAdding}
        >
          حفظ
        </Button>
      </div>
    </Form>
  );
}

export default CompanyData;
